var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEntranceLogs1 = function SvgEntranceLogs1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.083 12.063h-1.25v-8.82c0-.719-.56-1.305-1.25-1.305H9.667v1.687h2.5V13.75h2.916a.413.413 0 0 0 .417-.398v-.82c0-.282-.185-.47-.417-.47M7.8.277l-5 1.311c-.395.1-.632.449-.632.847v9.628H.917a.413.413 0 0 0-.417.398v.82c0 .282.186.469.417.469h7.916V1.124c0-.567-.507-.986-1.034-.847M6.542 7.844c-.345 0-.625-.38-.625-.82 0-.465.28-.82.625-.82s.625.332.625.796-.279.844-.625.844"
  })));
};
export default SvgEntranceLogs1;